import { createPortal } from 'react-dom';
import './modal.css';

function Modal({ show, children, width = '572px' }) {
    if (!show)
        return null;

    return createPortal(
        <>
            <div className="modal-overlay show"></div>
            <div className="modal show" style={{ width }}>
                {children}
            </div>
        </>,
        document.body
    );
}

export default Modal;